import React from "react";
import { Field } from "react-final-form";
import InputText from "@components/Form/InputText";

const HiddenInput = (props) => (
  <Field
    component={InputText}
    id={props.name}
    name={props.name}
    type="hidden"
  />
);

export default HiddenInput;
